import { Component } from '@angular/core';
import { PageLoginComponent } from '@infodata-group/inf-commons-desktop';

@Component({
  selector: 'ao-page-login',
  standalone: true,
  imports: [PageLoginComponent],
  templateUrl: './page-login.component.html',
  styleUrl: './page-login.component.scss',
})
export class PageLoginAOComponent {
  protected onBackgroundClick(linkedPage?: 'materiel'): void {
    if (linkedPage === 'materiel') {
      window.location.href =
        'https://infodata-group.eu/product/always-on-application-de-suivi-de-materiel/';
      return;
    }
    window.location.href = 'https://infodata-group.eu/product/always-on/';
  }
}
